import React from 'react';
import PropTypes from 'prop-types';
import ReactDOMServer from 'react-dom/server';
import { Map as LeafletMap, TileLayer, ZoomControl } from 'react-leaflet-universal';

import get from 'lodash/get';

if(typeof window !== 'undefined') {
    const L = require('leaflet');

    delete L.Icon.Default.prototype._getIconUrl;

    L.Icon.Default.mergeOptions({
        iconAnchor: [9, 9],
        iconSize: [18, 18],
        iconRetinaUrl: require('assets/marker-project-active.svg'),
        iconUrl: require('assets/marker-project-active.svg'),
        shadowUrl: null,
    });
}

import { isTouchDevice } from 'utils';

import Icon from 'components/Icon';

import './Map.scss';

export default class Map extends React.PureComponent {
    static propTypes = {
        center: PropTypes.array.isRequired,
        children: PropTypes.node,
        dragging: PropTypes.bool.isRequired,
        zoomLevel: PropTypes.number.isRequired,
        options: PropTypes.object,
        useZoom: PropTypes.bool,
        useScroll: PropTypes.bool,
        tileLayer: PropTypes.string.isRequired,
        fitMarkers: PropTypes.bool.isRequired,
    }

    static defaultProps = {
        center: [64.0655524, 13.7175499],
        dragging: !isTouchDevice(),
        zoomLevel: 5,
        useZoom: true,
        options: {},
        fitMarkers: false,
    }

    constructor(props) {
        super(props);
        this.map = null;
    }

    componentDidMount() {
        setTimeout(() => {
            this.leaflet && this.leaflet.leafletElement.invalidateSize();

            // Fixes issue with dragging still hijacking tap scroll
            // on mobile
            if(! this.props.dragging) {
                const tap = get(this.leaflet, 'leafletElement.tap');
                tap && tap.disable();
            }

            if(this.props.fitMarkers) {
                this.leaflet.leafletElement.eachLayer(layer => {
                    if(layer._markerCluster) {
                        this.leaflet.leafletElement.fitBounds(layer.getBounds());
                    }
                });
            }
        }, 1);

        if (window.matchMedia) {
            var mediaQueryList = window.matchMedia('print');
            mediaQueryList.addListener(mql => {
                if (mql.matches) {
                    this.leaflet && this.leaflet.leafletElement.invalidateSize()
                }
            });
        }
    }

    _zoomText(type) {
        return ReactDOMServer.renderToStaticMarkup(<Icon icon={`zoom-${type}`} />);
    }

    render() {
        const {
            center,
            children,
            dragging,
            zoomLevel,
            useZoom,
            options,
            tileLayer,
        } = this.props;

        return (
            <LeafletMap
                leafletRef={node => this.leaflet = node}
                ref={node => this.map = node}
                attributionControl={false}
                dragging={dragging}
                center={center}
                maxZoom={18}
                minZoom={4}
                zoom={zoomLevel}
                scrollWheelZoom={false}
                zoomControl={false}
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 0,
                    overflow: 'hidden',
                }}
                {...options}
            >
                <TileLayer url={tileLayer} useCache={true} />
                {children}
                {useZoom &&
                    <ZoomControl
                        zoomInText={this._zoomText('in')}
                        zoomOutText={this._zoomText('out')}
                        position="bottomright"
                    />
                }
            </LeafletMap>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Map/Map.jsx